export default "<picture>\n  <!-- <source [srcset]=\"darkSrc\" media=\"(prefers-color-scheme: dark)\"> -->\n  <img [src]=\"lightSrc\">\n</picture>";